'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function (routes) {
  return Object.keys(routes).map(function (key) {
    return routes[key];
  });
};


//////////////////
// WEBPACK FOOTER
// ./~/redux-first-router/dist/pure-utils/objectValues.js
// module id = 1088
// module chunks = 2